import React, { useEffect } from 'react';
import { Link } from 'react-scroll';
import { FaPhone, FaEnvelope } from 'react-icons/fa'; // Import icons
import './App.css';

const App = () => {
    useEffect(() => {
        // Prevent Ctrl + Scroll Zoom
        const preventZoom = (event) => {
            if (event.ctrlKey) {
                event.preventDefault();
            }
        };

        // Block Zoom on Mouse Wheel & Keyboard
        document.addEventListener("wheel", preventZoom, { passive: false });
        document.addEventListener("keydown", (event) => {
            if (event.ctrlKey && (event.key === "=" || event.key === "-" || event.key === "0")) {
                event.preventDefault();
            }
        });

        // Cleanup on Unmount
        return () => {
            document.removeEventListener("wheel", preventZoom);
            document.removeEventListener("keydown", preventZoom);
        };
    }, []);

    return (
        <div className="app" id="appContainer">
            {/* Fixed Navbar */}
            <nav className="navbar">
                <div className="logo">
                    <img src="/logo.svg" alt="Company Logo" />
                </div>
                <div className="contact-info">
                    <a href="tel:+972526916900" className="nav-contact">
                        <FaPhone className="nav-icon" /> 052-633-3427
                    </a>
                    <a href="mailto:contact@medical-prototypes.com" className="nav-contact">
                        <FaEnvelope className="nav-icon" /> contact@medical-prototypes.com
                    </a>
                </div>
                <ul className="nav-links">
                    <li>
                        <Link to="home" smooth={true} duration={200} containerId="appContainer">
                            About
                        </Link>
                    </li>
                    <span>|</span>
                    <li>
                        <Link to="medical" smooth={true} duration={200} containerId="appContainer">
                            Services
                        </Link>
                    </li>
                    <span>|</span>
                    <li>
                        <Link to="contact" smooth={true} duration={200} containerId="appContainer">
                            Contact
                        </Link>
                    </li>
                </ul>
            </nav>

            {/* Home Section with Video */}
            <section id="home" className="section home-section">
                <video autoPlay loop muted playsInline className="bg-video">
                    <source src="/background_home.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div className="home-content">
                    <h0>ENGINEERING</h0>
                    <h1> at The Heart of Innovation </h1>
                    <p>In times of peak workloads – we are your rapid-response team.</p>
                    <p> With established expertise in medical device design, engineering, and manufacturing, we’re the extra hand that helps you meet your ambitious deadlines – efficiently and seamlessly.</p>
                </div>
            </section>

            {/* Medical Section with Video */}
            <section id="medical" className="section medical-section">
                <video autoPlay loop muted playsInline className="bg-video">
                    <source src="/background_medical.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div className="content">
                    <h2>WHAT WE OFFER</h2>
                    <h1>Fast Delivery of Quality Prototypes</h1>
                    <p>We specialize in developing cutting-edge medical prototypes for various applications.</p>
                    <p>Nitinol Implants, Delivery Systems, Automated Testing Fixtures, Steerable Catheters, etc.</p>
                </div>
            </section>

            {/* Contact Section with Background Image */}
            <section id="contact" className="section contact-section">
                <div className="bg-image"></div> {/* Background image instead of video */}
                <div className="contact-content">
                    <h1>Contact Us</h1>
                    <p>For quotes and other information:</p>
                    <p><strong>Phone:</strong> +972-526333427</p>
                    <p><strong>WhatsApp:</strong> +972-526916900 (Calls & Messages)</p>
                    <p>
                        <strong>Email: </strong>
                        <a href="mailto:contact@medical-prototypes.com" className="email-link">
                            contact@medical-prototypes.com
                        </a>
                    </p>
                </div>
            </section>
        </div>
    );
};

export default App;
